<template>
	<div class="ag-theme-alpine" style="height: 400px; width: 100%">
		<ag-grid-vue
			:columnDefs="columnDefs"
			:rowData="rowData"
			:defaultColDef="defaultColDef"
			:domLayout="'autoHeight'"
			:gridOptions="gridOptions"
			:pagination="true"
			:paginationPageSize="10"
		></ag-grid-vue>
	</div>
</template>
  
  <script>
import { AgGridVue } from "ag-grid-vue";
export default {
	components: {
		AgGridVue,
	},
	data() {
		return {
			// Define columns with headers, including a parent header
			columnDefs: [
				{
					headerName: "Employee Name",
					field: "employeeName",
					pinned: "left", // Fix this column on the left side
					width: 150,
				},
				{
					headerName: "Netlink",
					children: [
						{ headerName: "Designation", field: "designation", width: 150 },
						{ headerName: "Location", field: "location", width: 150 },
						{ headerName: "Status", field: "status", width: 120 },
						{ headerName: "Rating", field: "rating", width: 100 },
					],
				},
				{
					headerName: "Others",
					children: [
						{
							headerName: "Current Salary",
							field: "currentSalary",
							width: 150,
							type: "numericColumn",
						},
						{ headerName: "Department", field: "department", width: 150 },
						{
							headerName: "Years of Experience",
							field: "experience",
							width: 150,
						},
						{ headerName: "Contact", field: "contact", width: 150 },
						{ headerName: "Email", field: "email", width: 200 },
					],
				},
			],
			// Define row data with dummy values
			rowData: [
				{
					employeeName: "John Doe",
					designation: "Software Engineer",
					location: "New York",
					status: "Active",
					rating: 5,
					currentSalary: 70000,
					department: "Engineering",
					experience: 5,
					contact: "123-456-7890",
					email: "johndoe@example.com",
				},
				{
					employeeName: "Jane Smith",
					designation: "Data Analyst",
					location: "London",
					status: "Inactive",
					rating: 4,
					currentSalary: 65000,
					department: "Analytics",
					experience: 3,
					contact: "987-654-3210",
					email: "janesmith@example.com",
				},
				// Add more rows as needed...
			],
			// Default column settings
			defaultColDef: {
				resizable: true,
				sortable: true,
				filter: true,
			},
			// Grid options
			gridOptions: {
				suppressHorizontalScroll: false,
			},
		};
	},
};
</script>
  
  <style scoped>
@import "https://unpkg.com/ag-grid-community/styles/ag-grid.css";
@import "https://unpkg.com/ag-grid-community/styles/ag-theme-alpine.css";
/* Ensure horizontal scroll is visible */
.ag-theme-alpine {
	width: 100%;
	overflow: auto;
}
</style>
  